import { createSelector } from 'reselect';
import Constants from './constants';

const stateSelector = state => state[Constants.MODULE_NAME];

export const TrackingSelectors = {
  stateSelector,
};
